/**
  申し込み用フォーム[JOBY]コンポーネント
*/
<template>
  <div id="formJOBY" class="form_group">
    <Section class="form_wrap form_list">
      <div class="rap1_boder" id="">
        <Section><h1 class="wrap_title pd_7">JOBY</h1></Section>
        <Column class="pd3_parts formJOBY">
          <label>JOBYキャンペーン</label>
          <ul class="c-choices">
            <li class="c-choices__item">
              <label class="c-choice">
                <input type="radio" name="JOBY_campaign" value="有り" class="required">
                <span class="">有り</span>
              </label>
            </li>
            <li class="c-choices__item">
              <label class="c-choice">
                <input type="radio" name="JOBY_campaign" value="無し" class="required">
                <span class="">無し</span>
              </label>
            </li>
          </ul>
        </Column>

        <Column class="pd3_parts formJOBY">
          <label>プラン</label>
          <ul class="c-choices">
            <li class="c-choices__item">
              <label class="c-choice">
                <input type="radio" class="required" name="JOBY_plan" id="JOBY_plan_lite" value="ライト">
                <span class="">ライト</span>
              </label>
            </li>
            <li class="c-choices__item">
              <label class="c-choice">
                <input type="radio" class="required" name="JOBY_plan" id="JOBY_plan_standard" value="スタンダード">
                <span class="">スタンダード</span>
              </label>
            </li>
            <li class="c-choices__item">
              <label class="c-choice">
                <input type="radio" class="required" name="JOBY_plan" id="JOBY_plan_complete" value="プレミアム">
                <span class="">プレミアム</span>
              </label>
            </li>
            <li class="c-choices__item">
              <label class="c-choice">
                <input type="radio" class="required" name="JOBY_plan" id="JOBY_plan_enterprise" value="エンタープライズ">
                <span class="">エンタープライズ</span>
              </label>
            </li>
          </ul>
        </Column>
        <Column class="pd3_parts formJOBY">
          <label>募集要項制作代行数</label>
          <input type="text" inputmode="numeric" class="required form_txt" placeholder="半角数字で入力" id="production_count_JOBY">
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>業界</label>
          <div class="c-select">
            <select name="industry_names_JOBY" id="industry_names_JOBY" class="required form_select">
              <option value="" disabled selected>--業種 選択--</option>
            </select>
          </div>
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>募集職種名</label>
          <input type="text" id="job_title_JOBY" class="form_txt">
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>追加オプション</label>
          <label class="c-choice documents"><input type="checkbox" name="additional_options_joby" value="インスタグラムのフィード制作オプション"><span>インスタグラムのフィード制作オプション</span></label>
          <label class="c-choice documents"><input type="checkbox" name="additional_options_joby" value="ロゴ制作オプション"><span>ロゴ制作オプション</span></label>
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>契約動機</label>
          <label class="c-choice documents"><input type="checkbox" class="required" name="motive_signing_contract_JOBY" value="慢性的人員不足の解消"><span>慢性的人員不足の解消</span></label>
          <label class="c-choice documents"><input type="checkbox" name="motive_signing_contract_JOBY" value="欠員"><span>欠員</span></label>
          <label class="c-choice documents"><input type="checkbox" name="motive_signing_contract_JOBY" value="増員"><span>増員</span></label>
          <label class="c-choice documents"><input type="checkbox" name="motive_signing_contract_JOBY" value="新店を増やすにあたってのスタートアップメンバーの募集"><span>新店を増やすにあたってのスタートアップメンバーの募集</span></label>
          <label class="c-choice documents"><input type="checkbox" name="motive_signing_contract_JOBY" value="管理者・経験者・資格保有者などの採用難易度が高い採用をしたい"><span>管理者・経験者・資格保有者などの採用難易度が高い採用をしたい</span></label>
          <label class="c-choice documents"><input type="checkbox" name="motive_signing_contract_JOBY" value="現場の若返りを図りたい"><span>現場の若返りを図りたい</span></label>
          <label class="c-choice documents"><input type="checkbox" name="motive_signing_contract_JOBY" value="今よりも採用コストを下げていきたい"><span>今よりも採用コストを下げていきたい</span></label>
          <label class="c-choice documents"><input type="checkbox" name="motive_signing_contract_JOBY" value="応募者の質を改善したい"><span>応募者の質を改善したい</span></label>
          <label class="c-choice documents"><input type="checkbox" name="motive_signing_contract_JOBY" value="経営に専念するための人員確保"><span>経営に専念するための人員確保</span></label>
          <label class="c-choice documents"><input type="checkbox" name="motive_signing_contract_JOBY" value="応募者情報を管理できる管理システムが欲しかった"><span>応募者情報を管理できる管理システムが欲しかった</span></label>
          <label class="c-choice documents"><input type="checkbox" name="motive_signing_contract_JOBY" value="イツザイ導入企業から実績を聞いての紹介"><span>イツザイ導入企業から実績を聞いての紹介</span></label>
          <label class="c-choice documents"><input type="checkbox" name="motive_signing_contract_JOBY" value="その他"><span>その他</span></label>
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>契約動機詳細</label>
          <div><textarea id="contractReason_JOBY" class="form_txt"></textarea></div>
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>顧客人柄</label>
          <p class="-attention">※カバーしなければいけない要素を確認させていただきたいです。<br>担当のアサインの際に活用します。</p>
          <label class="c-choice documents"><input type="checkbox" class="required" name="persnality_JOBY" value="採用リテラシー高い"><span>採用リテラシー高い</span></label>
          <label class="c-choice documents"><input type="checkbox" name="persnality_JOBY" value="採用リテラシー低い"><span>採用リテラシー低い</span></label>
          <label class="c-choice documents"><input type="checkbox" name="persnality_JOBY" value="機械操作が苦手"><span>機械操作が苦手</span></label>
          <label class="c-choice documents"><input type="checkbox" name="persnality_JOBY" value="非協力的"><span>非協力的</span></label>
          <label class="c-choice documents"><input type="checkbox" name="persnality_JOBY" value="こだわり強い"><span>こだわり強い</span></label>
          <label class="c-choice documents"><input type="checkbox" name="persnality_JOBY" value="こだわりなし＆任せたい"><span>こだわりなし＆任せたい</span></label>
          <label class="c-choice documents"><input type="checkbox" name="persnality_JOBY" value="こだわりなし＆教えてほしい"><span>こだわりなし＆教えてほしい</span></label>
          <label class="c-choice documents"><input type="checkbox" name="persnality_JOBY" value="プライド高い・相手を馬鹿にする"><span>プライド高い・相手を馬鹿にする</span></label>
          <label class="c-choice documents"><input type="checkbox" name="persnality_JOBY" value="極端な考え方をする・思い込み激しい"><span>極端な考え方をする・思い込み激しい</span></label>
          <label class="c-choice documents"><input type="checkbox" name="persnality_JOBY" value="反応薄い"><span>反応薄い</span></label>
          <label class="c-choice documents"><input type="checkbox" name="persnality_JOBY" value="高齢・前の話を忘れてしまう"><span>高齢・前の話を忘れてしまう</span></label>
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>お客様との会話内容（世間話を含めて）</label>
          <p class="-attention">※こういう話題してもらった方が<br>アイスブレイクになるなどがあれば教えてほしいです！<br>
            （例）<br>
            車好きの代表です。外車の話をしたらすごく盛り上がりました。<br>
            リテラシーが高いので知見提供し続けたり業界あるある話をして信用を得ると<br>本音を引き出しやすくなりました。など
          </p>
          <div><textarea id="conv_JOBY" class="form_txt"></textarea></div>
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>掲載希望日時（ヒアアポ～の期間・撮影期間を伝えた上で）</label>
          <div class="width60"><input type="date" id="shootDate_JOBY" class="required form_txt"></div>
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>求人背景（他媒体効果など）</label>
          <div class="width60"><input type="text" id="rctBackground_JOBY" class="form_txt"></div>
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>どういう人が取りたいか</label>
          <div><textarea id="kind_person_Hope_JOBY" class="form_txt"></textarea></div>
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>その他顧客希望</label>
          <div><textarea id="otherHope_JOBY" class="form_txt"></textarea></div>
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>備考</label>
          <div><textarea id="remarks_JOBY" class="form_txt"></textarea></div>
        </Column>
        <Column class="pd3_parts formJOBY width15">
          <label>JOBY契約総額</label>
          <input type="text" inputmode="numeric" class="required form_txt" id="JOBYContractFee">
        </Column>
        <Column class="pd3_parts formJOBY width15">
          <label>広告費</label>
          <input type="text" inputmode="numeric" class="required form_txt" id="JOBYAdvertisingFee">
        </Column>
        <Column class="pd3_parts formJOBY width15">
          <label>ATS（システム導入費）</label>
          <input type="text" inputmode="numeric" class="required form_txt" id="JOBYSystemFee">
        </Column>
        <Column class="pd3_parts formSharedComm">
          <label>広告費100万ブーストキャンペーンを適用しましたか？</label>
          <ul class="c-choices">
            <li class="c-choices__item">
              <label class="c-choice pd5_rl">
                <input type="radio" class="required form_check" name="boost_campaign_joby" value="はい">
                <span>はい</span>
              </label>
            </li>
            <li class="c-choices__item">
              <label class="c-choice pd5_rl">
                <input type="radio" class="required form_check" name="boost_campaign_joby" value="いいえ">
                <span>いいえ</span>
              </label>
            </li>
          </ul>
        </Column>
      </div>
    </Section>
  </div>
</template>


<script>
import { defineComponent } from 'vue';

// コンポーネントを読み込む
import Block from '../../../molecules/block.vue';
import Box from '../../../molecules/box.vue';
import Choices from '../../../molecules/choices.vue';
import Column from '../../../molecules/column.vue';
import Flex from '../../../molecules/flex.vue';
import Group from '../../../molecules/group.vue';
import Section from '../../../molecules/section.vue';
import Variables from '../../../molecules/variables.vue';

import Button from '../../../atoms/button.vue';
import Description from '../../../atoms/description.vue';
import IconAdd from '../../../atoms/icon-add.vue';
import IconRemove from '../../../atoms/icon-remove.vue';
import Input from '../../../atoms/input.vue';
import Label from '../../../atoms/label.vue';
import Select from '../../../atoms/select.vue';
import Textarea from '../../../atoms/textarea.vue';

export default defineComponent({
  name: 'formApplicationJOBY',

  components: {
    Variables,
    Choices,
    Box,
    Section,
    Column,
    Group,
    Flex,
    Block,

    Description,
    Label,
    Input,
    Select,
    Textarea,
    Button,
    IconAdd,
    IconRemove,
  },

  methods: {
  },

  mounted() {
  },

  setup(_, context) {
    return {}
  }

})
</script>
